import { config, createLocalVue, shallowMount } from '@vue/test-utils';
import Vuex from 'vuex';

/**** test module ******/
import VideoBanner from './VideoBanner';
import { getObjProperty } from "../../../../utilities/mrVueUtils";
/****** \(V_V)/ *********/

let wrapper;

describe('VideoBanner', function() {
  function createWrapper({ storeData, methods, attachToDocument } = {}) {
    const storeData_default = {
      modules: {
        'customer': {
          namespaced: true,
          state: {
            info: {
              'first_name': null,
            }
          },
        },
      },
    };

    const localVue = createLocalVue();
    localVue.use(Vuex);
    const store = new Vuex.Store(storeData || storeData_default);

    return shallowMount(VideoBanner, {
      localVue,
      store,
      methods,
      provide: {
        getObjProperty
      },
      attachToDocument,
    });
  }

  describe('video used', () => {
    it('uses specific videos for various breakpoints', () => {
      config.mocks['windowData'] = {
        breakpoint: 'mobile'
      };
      wrapper = createWrapper();
      expect(wrapper.find('video').attributes('src').includes('MOBILE')).toBe(true);

      config.mocks['windowData'].breakpoint = 'desktop';
      wrapper = createWrapper();
      expect(wrapper.find('video').attributes('src').includes('DESKTOP')).toBe(true);
    });
  });

  describe('address visitor', () => {
    it("displays the visitor's name if it is available", () => {
      wrapper = createWrapper();
      expect(wrapper.find('.welcome-text > #guest-name').text()).toBe('Beautiful');
      
      const storeData = {
        modules: {
          customer: {
            namespaced: true,
            state: {
              info: {
                first_name: 'Madison',
              },
            },
          },
        },
      };

      wrapper = createWrapper({ storeData });
      expect(wrapper.find('.welcome-text > #guest-name').text()).toBe('Madison');
    });
    
  });

  describe('error on loading video', () => {
    config.mocks['windowData'] = {
      breakpoint: 'mobile'
    };

    wrapper = createWrapper();
    expect(wrapper.find('.video-banner').isVisible()).toBe(true);
    expect(wrapper.find('.image-banner').isVisible()).toBe(false);
    expect(wrapper.find('.video-toggle').isVisible()).toBe(true);

    wrapper.setData({
      media: {
        video: {
          mobile: 'yes this is link',
        },
      },
      fallbackToImage: true,
    });

    expect(wrapper.find('.video-banner').isVisible()).toBe(false);
    expect(wrapper.find('.image-banner').isVisible()).toBe(true);
    expect(wrapper.contains('.video-toggle')).toBe(false);
  });
   
  describe('pause/resume video', () => {
    const methods = {
      pauseVideo: jest.fn(),
      playVideo: jest.fn(),
    };
    wrapper = createWrapper({ methods });

    expect(wrapper.vm.videoPaused).toEqual(false);

    wrapper.find('.video-toggle').trigger('click');

    expect(wrapper.vm.videoPaused).toEqual(true);
  });
});
